export default "__VITE_ASSET__DTYSBzSV__"